import { useEffect, useState } from 'react';

import { api, SortingHatControllerState } from '../../../api';
import type { FeatureContext } from '../../types';
import './sorting-hat-debug.css';

export function SortingHatDebugFeature({ isAuthenticated }: FeatureContext) {
  const [state, setState] = useState<SortingHatControllerState | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  async function loadState() {
    setLoading(true);
    setError(null);
    try {
      const result = await api.getSortingHatState();
      setState(result);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Unable to fetch game state.');
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    if (!isAuthenticated) {
      setError('Sign in to view the Sorting Hat debug state.');
      return;
    }
    void loadState();
  }, [isAuthenticated]);

  return (
    <section className="page-section sorting-hat-debug">
      <div className="sorting-hat-debug__card">
        <div className="sorting-hat-debug__header">
          <div>
            <h2>Sorting Hat Debug</h2>
            <p>Fetch the latest Sorting Hat controller state for debugging.</p>
          </div>
          <button type="button" onClick={loadState} disabled={loading}>
            {loading ? 'Refreshing...' : 'Refresh'}
          </button>
        </div>

        {error && (
          <p className="sorting-hat-debug__error" role="alert">
            {error}
          </p>
        )}

        {state && (
          <pre className="sorting-hat-debug__payload">{JSON.stringify(state, null, 2)}</pre>
        )}
      </div>
    </section>
  );
}
